module.exports = __webpack_public_path__ + "static/media/img_MRII.e8952d62.jpg";